import React from 'react';

/**
 * Justins ThugDebugger Logo
 * @param {string} The external link the icon points to
 */
export function JustinLogo({ link }) {
  return (
    <a href={link} aria-label="ThugDebugger-logo">
      <svg viewBox="0 0 125.95 17.26" width="150px" height="22px">
        <path d="M56.87 13.81h-3.58V4.73h3.58c1.3 0 2.36.38 3.19 1.14.45.41.78.89 1.01 1.47.23.57.34 1.22.34 1.93 0 .72-.11 1.37-.34 1.94-.23.57-.56 1.07-1.01 1.47-.4.37-.88.65-1.42.84-.54.2-1.13.29-1.77.29zm-1.85-1.54h1.85c.32 0 .65-.04.98-.11.33-.07.63-.22.9-.44s.49-.52.66-.91c.17-.39.26-.9.26-1.53s-.09-1.14-.26-1.53c-.17-.39-.4-.7-.67-.91s-.57-.36-.91-.43c-.33-.07-.65-.11-.97-.11h-1.85v5.97zM64.39 6.27v2.27h4.39v1.58h-4.39v2.13h4.95v1.56h-6.68V4.73h6.68v1.54h-4.95zM77.77 7.26c0 .18-.04.38-.11.58-.07.21-.18.4-.3.57-.13.17-.28.32-.46.44s-.38.18-.6.19c.22.02.44.08.66.19.22.11.42.26.59.45.17.19.32.41.43.66.11.25.17.51.17.79 0 .5-.07.91-.22 1.26-.15.34-.35.62-.61.83-.26.21-.56.36-.9.45-.34.09-.71.14-1.1.14h-4.19V4.73h3.99c.36 0 .71.04 1.03.11.32.07.6.2.84.38.24.19.43.44.57.77.14.33.21.75.21 1.27zm-4.91 1.17h2.13c.17 0 .32-.03.45-.1s.24-.15.32-.26c.09-.11.15-.23.2-.37a1.179 1.179 0 000-.8 1.091 1.091 0 00-.49-.55.73.73 0 00-.35-.09h-2.26v2.17zm2.45 3.84c.15 0 .29-.03.42-.11.13-.07.25-.16.35-.28.1-.12.18-.25.24-.4.06-.14.09-.29.09-.44 0-.31-.11-.56-.34-.77-.23-.21-.54-.31-.94-.31h-2.27v2.31h2.45zM83.44 13.97c-.59 0-1.12-.09-1.6-.27-.48-.18-.89-.44-1.23-.77-.34-.33-.6-.73-.79-1.2-.19-.47-.28-1-.28-1.58v-5.4h1.74v5.4c0 .45.07.83.22 1.13.15.3.33.53.55.71.22.17.45.29.71.36s.48.1.68.1c.2 0 .42-.03.68-.1.25-.07.49-.19.71-.36.22-.17.4-.41.55-.71.15-.3.22-.67.22-1.13v-5.4h1.74v5.41c0 .58-.09 1.1-.27 1.58-.18.47-.44.87-.78 1.2s-.75.59-1.23.77c-.49.17-1.03.26-1.62.26zM98.13 8.85c-.01.17-.01.34-.01.48-.01.13-.01.26-.01.39s0 .23-.01.29c-.05.57-.2 1.1-.47 1.59-.26.49-.6.91-1 1.26a4.728 4.728 0 01-3.09 1.13c-.64 0-1.25-.12-1.82-.37a4.817 4.817 0 01-2.52-2.5c-.25-.57-.37-1.18-.37-1.82s.12-1.25.37-1.83c.25-.57.59-1.07 1.02-1.5s.93-.76 1.5-1.01 1.18-.37 1.82-.37c.82 0 1.57.19 2.25.57.68.38 1.23.89 1.66 1.52l-1.49.91c-.26-.39-.61-.71-1.04-.98-.43-.26-.89-.4-1.38-.4-.41 0-.8.09-1.16.25a3.185 3.185 0 00-1.58 1.67 2.988 2.988 0 000 2.35 3.189 3.189 0 001.58 1.66c.36.17.75.25 1.16.25.31 0 .62-.05.91-.14.29-.1.55-.23.79-.4s.45-.38.63-.62.31-.5.39-.79H92.9V8.85h5.23zM108.4 8.85c-.01.17-.01.34-.01.48-.01.13-.01.26-.01.39s0 .23-.01.29c-.05.57-.2 1.1-.47 1.59-.26.49-.6.91-1 1.26a4.728 4.728 0 01-3.09 1.13c-.64 0-1.25-.12-1.82-.37a4.817 4.817 0 01-2.52-2.5c-.25-.57-.37-1.18-.37-1.82s.12-1.25.37-1.83c.25-.57.59-1.07 1.02-1.5s.93-.76 1.5-1.01 1.18-.37 1.82-.37c.82 0 1.57.19 2.25.57.68.38 1.23.89 1.66 1.52l-1.49.91c-.26-.39-.61-.71-1.04-.98-.43-.26-.89-.4-1.38-.4-.41 0-.8.09-1.16.25a3.185 3.185 0 00-1.58 1.67 2.988 2.988 0 000 2.35 3.189 3.189 0 001.58 1.66c.36.17.75.25 1.16.25.31 0 .62-.05.91-.14.29-.1.55-.23.79-.4s.45-.38.63-.62.31-.5.39-.79h-3.35V8.85h5.22zM111.59 6.27v2.27h4.39v1.58h-4.39v2.13h4.95v1.56h-6.68V4.73h6.68v1.54h-4.95zM120.06 13.81h-1.74V4.73h4.12c.46 0 .89.08 1.27.23.38.15.71.37.99.64.27.28.49.61.64.99.15.38.23.8.23 1.26 0 .69-.17 1.29-.52 1.8-.34.51-.8.88-1.37 1.1.76 1.01 1.52 2.03 2.26 3.05h-2.07c-.36-.47-.72-.95-1.06-1.43-.35-.48-.69-.97-1.04-1.46h-1.72v2.9zm0-4.43h2.39c.16 0 .32-.03.49-.09.17-.06.32-.16.45-.28a1.541 1.541 0 00.46-1.15c0-.13-.02-.29-.05-.47-.03-.18-.1-.36-.2-.52-.1-.16-.24-.31-.42-.42-.18-.12-.42-.17-.73-.17h-2.39v3.1z" />
        <g>
          <linearGradient
            id="b"
            gradientUnits="userSpaceOnUse"
            x1={4.714}
            y1={2.381}
            x2={18.577}
            y2={18.617}
          >
            <stop offset={0} stopColor="#000075" />
            <stop offset={0.724} stopColor="#591ac1" />
            <stop offset={0.901} stopColor="#8628e8" />
          </linearGradient>
          <path
            fill="url(#b)"
            d="M6.05 6.91h2.32v6.72h2.16V6.91h2.31V4.93H6.05z"
          />
          <linearGradient
            id="c"
            gradientUnits="userSpaceOnUse"
            x1={9.346}
            y1={-1.575}
            x2={23.209}
            y2={14.662}
          >
            <stop offset={0} stopColor="#000075" />
            <stop offset={0.724} stopColor="#591ac1" />
            <stop offset={0.901} stopColor="#8628e8" />
          </linearGradient>
          <path
            fill="url(#c)"
            d="M20.3 8.43h-3.38v-3.5h-2.15v8.7h2.15v-3.22h3.38v3.22h2.16v-8.7H20.3z"
          />
          <linearGradient
            id="d"
            gradientUnits="userSpaceOnUse"
            x1={15.397}
            y1={-6.741}
            x2={29.26}
            y2={9.495}
          >
            <stop offset={0} stopColor="#000075" />
            <stop offset={0.724} stopColor="#591ac1" />
            <stop offset={0.901} stopColor="#8628e8" />
          </linearGradient>
          <path
            d="M29.81 10.05c0 .36-.06.65-.17.87-.11.22-.25.4-.41.53-.16.13-.33.22-.52.26-.4.11-.66.1-1.05 0-.19-.05-.36-.14-.52-.27a1.5 1.5 0 01-.41-.53c-.11-.22-.17-.51-.17-.87v-5.1h-2.15v5.12c0 .55.09 1.06.27 1.51.18.46.44.85.77 1.18.33.32.73.58 1.2.75.46.17.97.26 1.53.26.57 0 1.08-.09 1.54-.26.46-.18.87-.43 1.2-.75.33-.32.59-.72.77-1.18.17-.45.26-.96.26-1.51V4.94H29.8v5.11z"
            fill="url(#d)"
          />
          <linearGradient
            id="e"
            gradientUnits="userSpaceOnUse"
            x1={20.56}
            y1={-11.149}
            x2={34.423}
            y2={5.087}
          >
            <stop offset={0} stopColor="#000075" />
            <stop offset={0.724} stopColor="#591ac1" />
            <stop offset={0.901} stopColor="#8628e8" />
          </linearGradient>
          <path
            d="M37.14 8.6v2h2.84c-.04.08-.09.15-.14.22-.14.19-.3.35-.49.49s-.4.24-.62.32c-.52.17-1.13.14-1.61-.09a2.57 2.57 0 01-.75-.54c-.21-.22-.38-.48-.51-.78-.12-.29-.19-.61-.19-.93 0-.32.06-.63.19-.93.12-.3.3-.56.51-.79.21-.22.46-.4.75-.54.61-.29 1.36-.27 1.97.11.34.21.62.48.83.79l.16.24 1.84-1.12-.17-.26c-.4-.6-.93-1.1-1.58-1.46a4.487 4.487 0 00-3.9-.19c-.54.24-1.02.56-1.43.96-.41.41-.74.9-.98 1.44-.24.55-.36 1.14-.36 1.75s.12 1.2.36 1.75c.24.54.56 1.02.97 1.43.41.4.89.73 1.43.96.54.24 1.13.36 1.75.36.56 0 1.1-.1 1.6-.28.51-.19.96-.45 1.35-.79.39-.34.72-.74.97-1.21s.4-.98.45-1.52c.01-.07.01-.17.01-.3 0-.11 0-.22.01-.35 0-.13 0-.27.01-.42l.02-.32h-5.29z"
            fill="url(#e)"
          />
          <g>
            <linearGradient
              id="f"
              gradientUnits="userSpaceOnUse"
              x1={25.512}
              y1={-15.378}
              x2={39.375}
              y2={0.859}
            >
              <stop offset={0} stopColor="#000075" />
              <stop offset={0.724} stopColor="#591ac1" />
              <stop offset={0.901} stopColor="#8628e8" />
            </linearGradient>
            <path
              d="M46.46 17.26c.22 0 .43-.1.58-.27.49-.6 1.6-2.14 1.6-3.84 0-2.19-.92-2.8-.92-3.45 0-.34.25-.62.49-.81a.34.34 0 000-.53c-.24-.19-.49-.46-.49-.81 0-.65.92-1.26.92-3.45 0-1.7-1.1-3.24-1.6-3.84a.804.804 0 00-.58-.26h-1.2c-.24 0-.38.28-.23.47.54.7 1.44 2.1 1.44 3.64 0 2.19-.92 2.8-.92 3.45 0 .23.11.43.26.6.24.27.24.68 0 .95-.15.16-.26.37-.26.6 0 .65.92 1.26.92 3.45 0 1.47-.82 2.81-1.36 3.54-.18.24-.01.57.29.57h1.06z"
              fill="url(#f)"
            />
          </g>
          <g>
            <linearGradient
              id="g"
              gradientUnits="userSpaceOnUse"
              x1={0.417}
              y1={6.049}
              x2={14.281}
              y2={22.285}
            >
              <stop offset={0} stopColor="#000075" />
              <stop offset={0.724} stopColor="#591ac1" />
              <stop offset={0.901} stopColor="#8628e8" />
            </linearGradient>
            <path
              d="M2.17 0c-.22 0-.43.1-.57.27C1.1.87 0 2.41 0 4.11c0 2.19.92 2.8.92 3.45 0 .34-.25.62-.49.81a.34.34 0 000 .53c.23.18.49.46.49.8 0 .65-.92 1.26-.92 3.45 0 1.7 1.1 3.24 1.6 3.84.14.17.35.27.58.27h1.2c.24 0 .38-.28.23-.47-.54-.7-1.44-2.1-1.44-3.64 0-2.19.92-2.8.92-3.45 0-.23-.11-.43-.26-.6a.717.717 0 010-.95c.15-.16.26-.37.26-.6 0-.65-.92-1.26-.92-3.45 0-1.47.82-2.81 1.36-3.54.18-.23.01-.56-.28-.56H2.17z"
              fill="url(#g)"
            />
          </g>
        </g>
      </svg>
    </a>
  );
}
